module.exports = __webpack_public_path__ + "static/media/germany.b442d3c5.jpg";